<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.33301 10.7666V12.5666C7.33301 14.0666 6.73301 14.6666 5.23301 14.6666H3.43301C1.93301 14.6666 1.33301 14.0666 1.33301 12.5666V10.7666C1.33301 9.26663 1.93301 8.66663 3.43301 8.66663H5.23301C6.73301 8.66663 7.33301 9.26663 7.33301 10.7666Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 10C14.6667 12.58 12.58 14.6667 10 14.6667L10.7 13.5"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33301 6.00004C1.33301 3.42004 3.41967 1.33337 5.99967 1.33337L5.29967 2.50004"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.667 7.33337C13.3238 7.33337 14.667 5.99023 14.667 4.33337C14.667 2.67652 13.3238 1.33337 11.667 1.33337C10.0101 1.33337 8.66699 2.67652 8.66699 4.33337C8.66699 5.99023 10.0101 7.33337 11.667 7.33337Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "moving-icon",
};
</script>

<style lang="scss" scoped></style>
